// extracted by mini-css-extract-plugin
export default {"primaryColor":"#f92323","primaryColorWithAlpha":"rgba(247,93,190,.1019607843)","mainBgColor":"#111322","secondBgColor":"#1e2035"};